import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { CurrencySymbolMap } from "@reside/forms/dist/templateTypes";
import { TextField } from "../text-field";
/**
 * A formik field for currency input.
 *
 * @param {Props} props The props for the component.
 * @returns {JSX.Element} The rendered currency field component.
 */
export const CurrencyField = ({ currency, ...props }) => (_jsx(TextField, { ...props, renderBefore: () => _jsx(_Fragment, { children: CurrencySymbolMap[currency] }), min: 0, type: "number" }));
CurrencyField.defaultProps = {
    currency: "USD",
    fractionalDigits: 2,
    step: "0.01",
};
